/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-公告管理
 */
'use strict';
angular.module("noticeManagementModule",[
    'noticeManagementRouter',
    'newNoticeRouterModule',//新建公告
    'noticeDetailsModule',//公告详情
    'loginPageMangementModule'
    ]).
controller('noticeManagementCtrl', ['$scope','httpService','$filter','$state','modalDialog',function($scope,httpService,$filter,$state,modalDialog){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 0
        };
        $scope.data = {
            listData: [],
            selectedArray: [], //选中的数据
        };
        $scope.params = {
            startTime: '',
            endTime: '',
            searchWord: ''
        };
        addChildRefresh();
        initDropDownList();
    };

    function initData(){
        requestData();
    };
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
        $scope.status.statusOptions = [{
            name: "全部状态",
            value: ''
        }, {
            name: "未发布",
            value: 0
        }, {
            name: "已发布",
            value: 1,
        }];
        $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
    }
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };

    function requestData() {
        $scope.data.selectedArray = [];
        var params = {
            noticeStatus:$scope.status.selectedStatus.value,
            startTime: $scope.params.startTime,
            endTime: $scope.params.endTime,
            keyword: '',
            queryTime: '',
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/notice/list.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        });
    };
    /**
     * [dateFormat description] 时间格式化
     * @return {[type]} [description]
     */
    $scope.dateFormat = function(item) {
        item.newTime = $filter("date")(item.crtime, "yyyy-MM-dd HH:mm:ss").toString();
    };
    /**
     * [queryByDropdown description] 筛选条件触发后请求数据
     * @param  {[type]} key   [description] 请求对象参数key
     * @param  {[type]} value [description] 请求对象值
     * @return {[type]}       [description] null
     */
    $scope.queryByDropdown = function() {
        $scope.params.startTime = $scope.status.startDate;
        $scope.params.endTime = $scope.status.endDate;
        requestData();
    };
    
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectNotice = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    /**
     * [cancelPubNotice description] 取消发布公告
     * @param  {[type]}  [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.cancelPubNotice = function(){
    	modalDialog.backConfirmModal("取消发布", "确认取消发布选中公告？", function() {
            var params = {
                ids: angular.packageIds($scope.data.selectedArray,",","id")
            };
            httpService.http("/mcnadmin/admin/notice/cancelPub.do", params, "post").then(function(data) {
            	modalDialog.alertType('','取消发布成功','success')
                requestData();
            });
        });
    }
    /**
     * [pubNotice description] 发布公告
     * @param  {[type]}  [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.pubNotice = function(){
    	modalDialog.backConfirmModal("发布", "确认发布选中公告？", function() {
            var params = {
                ids: angular.packageIds($scope.data.selectedArray,",","id")
            };
            httpService.http("/mcnadmin/admin/notice/allowPub.do", params, "post").then(function(data) {
            	modalDialog.alertType('','发布成功','success')
                requestData();
            });
        });
    }
    /**
     * [pubNotice description] 删除公告
     * @param  {[type]}  [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.deleteNotice = function(){
    	modalDialog.backConfirmModal("删除", "确认删除选中公告？", function() {
            var params = {
                ids: angular.packageIds($scope.data.selectedArray,",","id")
            };
            httpService.http("/mcnadmin/admin/notice/delete.do", params, "post").then(function(data) {
            	modalDialog.alertType('','删除成功','success')
                requestData();
            });
        });
    }
    /**
     * [createDraft description] 新建稿件
     * @return {[type]} [description]
     */
    $scope.createDraft = function() {
        var url = $state.href("newnotice",{docId:0,type:1});
        window.open(url);
    };
    
    /**
     * [addChildRefresh description] 监听子页面保存，并刷新本身
     */
    function addChildRefresh() {
        window.addEventListener("storage", function(e) {
            if (e.key === "ls.refresh") {
                requestData();
            }
        }, false);
    }
}]);